import { useEffect, useState } from "react";
import BoxPrenotationByBooking from "./boxPrenotationByBooking"
import { HttpService } from "../../services/HttpService";
import { useSelector } from "react-redux";
import { updateSelectedBookingId } from "../../redux/reducer/prenotationViewReducer";
import { useAppDispatch } from "../../redux";
import PopUpNote from "../popUpNote";

const ListingPrenotationByBookingId = (props: any) => {
  // internal state
  const [bookings, setBookings] = useState([]);
  const [success, setSuccess] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [showPopUpNote, setShowPopUpNote] = useState(false);
  const [attendanceFullName, setAttendanceFullName] = useState("");

  // redux state
  const { selectedTimeslotId, selectedBookingId } = useSelector((state: any) => state.prenotationView);
  const { eventId } = useSelector((state: any) => state.login);
  const dispatch = useAppDispatch();

  /**
   * Update bookings in the list, fetching from server.
   */
  const loadBookings = () => {
    if (!selectedTimeslotId) {
      return;
    }

    HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/${selectedTimeslotId}/bookings`).then(response => {
      const incomingBookings = response.data;
      setBookings(incomingBookings);

      // if no booking specified, select the first one
      if (!selectedBookingId && incomingBookings.length > 0) {
        dispatch(updateSelectedBookingId(incomingBookings[0]._id))
      }
    }).catch(error => {
      console.log(error)
      setBookings([])
    });
  };

  /**
   * Close PopUp Note.
   */
  const closePopUpNote = () => {
    setBookingId("");
    setAttendanceFullName("");
    setShowPopUpNote(false)
  }
  /**
   * Open PopUp Note.
   */
  const openPopUpNote = (booking: string, attendanceFullName: string) => {
    setBookingId(booking);
    setAttendanceFullName(attendanceFullName);
    setShowPopUpNote(true);
  }

  /**
   * Load timeslot bookings when selectedTimeslotId changes.
   */
  useEffect(() => {
    loadBookings();
  }, [selectedTimeslotId]);

  return (
    <>
      {/* {((success != "") ?
        <SuccessMessageBox successMessage={success} />
        :
        <></>
      )} */}
      <div className="mt-4 scrollY">
        {bookings?.map((booking: any, index: any) => (
          <div key={booking._id} id={"booking" + booking._id}>
            <BoxPrenotationByBooking
              changeInfoOldAttendances={props?.changeInfoOldAttendances}
              openBox={booking._id === selectedBookingId}
              // setSuccess={setSuccess}
              attendances={booking.attendances}
              openPopUpNote={openPopUpNote}
              updateBookings={loadBookings} // trigger update after move or delete
            />
          </div>
        ))}
      </div>
      <PopUpNote bookingId={bookingId} attendanceFullName={attendanceFullName} show={showPopUpNote} closePopUp={() => (closePopUpNote())} />
    </>

  )
}

export default ListingPrenotationByBookingId